<div>
	<span>0</span>
	<span>25</span>
	<span>50</span>
	<span>75</span>
	<span>100</span>
</div>
